import data from '../../assets/Dictionary/bundestagWahlkreise';
import { setUrlToDataSource } from '@/tools/setUrlToDataSource';
import { mutationTypes } from '@/types';
import { uiComponents, uiStates } from '@/tools/viewState';

/* eslint-disable no-prototype-builtins*/

// turning this rule off because
// rule off if your code only touches objects with hardcoded keys,
// and you will never use an object that shadows an Object.prototype method or
// which does not inherit from Object.prototype

export default function openCardView({ commit, state, rootState }, { code }) {
	const { fileData, mediaObjectsInfo } = state.dataSourceCFG;
	if (data.hasOwnProperty(parseInt(code))) {
		const value = data[parseInt(code)];
		const filteredFileData = fileData
			.filter((fd) => fd.sheetName === value)
			.map((sheet) => sheet.sheetData)
			.flat(1)
			.filter((sd) => sd.disctId === Number(code));
		const { mediaObjectsForWebStations = [] } = mediaObjectsInfo;
		let mediaObjects = mediaObjectsForWebStations
			.filter((mediaObject) => mediaObject.tags.includes(code))
			.map((mb) => {
				return {
					languageContent: mb.languageContent,
					mediaObj: mb,
				};
			});
		let cardData = filteredFileData.map((fileData) => {
			return mediaObjects.map((mediaObject) => {
				const { tags, languageContent } = mediaObject.mediaObj;
				// const [, , name] = tags.split(',');
				if (tags.includes(fileData.disctId.toString()) && tags.includes(fileData.name)) {
					return {
						attribution: languageContent[0].attribution,
						altText: languageContent[0].altText,
						sourceURL: setUrlToDataSource(
							`../media-${languageContent[0].source}/2048`,
							rootState.dataSourceURL
						),
						birthInfo: fileData.birthInfo,
						disctId: fileData.disctId,
						disctName: fileData.disctName,
						elected: fileData.elected,
						name: fileData.name,
						party: fileData.party,
					};
				}
			});
		});
		cardData = cardData.flat(1).filter(Boolean);
		commit(mutationTypes.setCardData, { cardData: cardData });
		commit(mutationTypes.viewStateSetUiState, [{ id: uiComponents.uiCard, uiState: uiStates.maximised }]);
	}
}
